export default __webpack_public_path__ + "static/media/satisfaction.ef38d098.png";